import { createContext } from "react";

const conferencesContext = createContext();

export default conferencesContext;